module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-segment-visualisation-middle.e639ccef.png";